module.exports = __webpack_public_path__ + "img/mingshixiangqing_bg.dac204ad.png";